<template>
  <div>
    <div style="display: block; height: 24px;"></div>
    <template  v-if="shipmentDrops.length > 0 && !this.getShipmentIsFetching">
      <ListItemCardBig
        v-for="item in shipmentDrops"
        :key="item.objectID"
        :resource="{...item, id: item.id}"
        :isCheckable="false"
        :isSelectable="false"
        color="#ef476f"
        @card-clicked="handleDropClick"
      >
        <ShipmentsDropItemCard :drop="item" />
      </ListItemCardBig>
    </template>
    <div v-else-if="this.getShipmentIsFetching">
      <div class="drop--sortable--tree__container">
          <div v-for="(key, index) in new Array(10)" :key="index" class="drop--sortable--tree__card drop--sortable--tree--card__topLevel placeholderLoader background--transparent">
          </div>
      </div>
    </div>
    <div v-else>
      <span class="headline">Empty Drops</span>
    </div>
  </div>
</template>

<script>
import ListItemCardBig from '@/components/wrld/generic/ListItemCardBig'
import ShipmentsDropItemCard from '@/components/shipments/new/drops/ShipmentsDropItemCard'
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'ShipmentDropsContent',
  components: {
    ListItemCardBig,
    ShipmentsDropItemCard
  },
  mounted () {
    if (this.getSelectedResourceID.objectID === null) {
      this.setShipmentOverviewDrops({ shipmentID: this.$route.params.shipmentID })
    }
  },
  methods: {
    ...mapActions({
      updateResource: 'updateResource',
      setShipmentDetails: 'setShipmentDetails',
      setShipmentsDropsUnitsCountStatus: 'setShipmentsDropsUnitsCountStatus',
      setShipmentOverviewDrops: 'setShipmentOverviewDrops',
      setShipmentDetailDrops: 'setShipmentDetailDrops'
    }),
    handleDropClick (dropID) {
      const routerData = this.$router.resolve({ name: 'DropDetail', params: { dropID: dropID } })
      window.open(routerData.href, '_blank')
    }
  },
  computed: {
    ...mapGetters([
      'getSelectedResourceID',
      'getShipmentResourceDrops',
      'getShipmentResourceDropsDetails',
      'getShipmentResourceDetails',
      'getShipmentIsFetching'
    ]),
    shipmentDrops: function () {
      return this.getShipmentResourceDrops != null ? this.getShipmentResourceDrops : []
    }
  },
  watch: {
    getShipmentResourceDrops: {
      deep: true,
      immediate: true,
      handler (val, oldVal) {
        if (val != null) {
          if (val.length > 0) {
            // this.setShipmentDetailDrops({ drops: val.map(({ id }) => id) })
          }
        } else if (this.$route.params.shipmentID != null) {
          this.setShipmentOverviewDrops({ shipmentID: this.$route.params.shipmentID })
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
